(function () {
  var banner = document.getElementById('pl-access-banner');
  if (!banner) return;

  var setCookie = function (name, value, expiryDays) {
    var d = new Date();
    d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/;SameSite=Lax';
  };

  var getCookie = function (name) {
    var cookieName = name + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookies = decodedCookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return null;
  };

  // Don't show if the user has already confirmed their professional status
  if (getCookie('plProfessionalConfirmed')) {
    banner.remove();
    return;
  }

  // Show banner and prevent background scrolling
  banner.classList.remove('hidden');
  document.body.style.overflow = 'hidden';

  // Focus the confirm button for accessibility
  var confirmBtn = banner.querySelector('.pl-access-banner__confirm');
  if (confirmBtn) {
    confirmBtn.focus();

    confirmBtn.addEventListener('click', function () {
      setCookie('plProfessionalConfirmed', 'true', 365);
      banner.classList.add('hidden');
      document.body.style.overflow = '';
    });
  }

  // Prevent closing by clicking the backdrop
  banner.addEventListener('click', function (e) {
    if (e.target === banner) {
      e.stopPropagation();
    }
  });

  // Prevent ESC from closing (mandatory acknowledgement)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !banner.classList.contains('hidden')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}());
